<div [formGroup]="Form">
  <div class="row country-and-regions">
    <div [ngClass]="{ 'col-lg-6 country-padding mb-lg-0': !SeparateRow, 'col-lg-12': SeparateRow }">
      <div class="form-floating">
        <select
          (change)="this.getRegionsByCountry($event.target.value)"
          id="Country"
          class="form-select"
          name="Country"
          formControlName="Country"
          [ngClass]="{ 'is-invalid': HasSubmitted && !!Form.controls.Country.errors }"
          required
        >
          <option value="" selected disabled hidden>{{ 'country.options.default.select' | translate }}</option>
          <option *ngFor="let country of countryOptions" [value]="country.CountryName">
            {{ country.DisplayName }}
          </option>
        </select>
        <label for="Country">{{ 'address.country.label' | translate }}</label>
        <div class="invalid-feedback">{{ 'address.missing.country' | translate }}</div>
      </div>
    </div>
    <div [ngClass]="{ 'col-lg-6 mb-lg-0': !SeparateRow, 'col-lg-12 ': SeparateRow }">
      <div class="form-floating">
        <select
          *ngIf="regionOptions.length > 1"
          id="County"
          class="form-select"
          name="County"
          type="text"
          formControlName="County"
          [ngClass]="{ 'is-invalid': HasSubmitted && !!Form.controls.County.errors }"
          required
        >
          <option value="" selected disabled hidden>{{ 'region.options.default.select' | translate }}</option>
          <option *ngFor="let region of regionOptions" value="{{ region.RegionName }}">
            {{ region.DisplayName }}
          </option>
        </select>

        <input
          *ngIf="regionOptions[0] == null"
          id="County"
          class="form-control"
          name="County"
          type="text"
          formControlName="County"
          [ngClass]="{ 'is-invalid': HasSubmitted && !!Form.controls.County.errors }"
          required
        />
        <label for="County">{{ 'address.region.label' | translate }}</label>
        <div *ngIf="regionOptions.length > 1" class="invalid-feedback">{{ 'address.missing.region.select' | translate }}</div>
        <div *ngIf="regionOptions[0] == null" class="invalid-feedback">{{ 'address.missing.region.entry' | translate }}</div>
      </div>
    </div>
  </div>
</div>
